/* So Simple: новите оферти на продуктовата страница, поп-ъпът с оферти и действията в количката.
   Образец: so-simple-site-demo.vercel.app. Количката се рисува от темата (секция cart-drawer);
   тук само се добавя/променя и се подава отговорът на CartDrawer.renderContents. */
(function () {
  const CFG = window.ssoOffers || {};
  // текстовете в JS; RO (13.10.2026) ги подава от layout/theme.liquid като CFG.t
  const T = Object.assign({
    added: 'Добавено', add: 'Добави', more: 'Още', to: 'до',
    done: 'Отключихте безплатна доставка, подарък изненада и несесер',
    hide: 'Скрий', readMore: 'Прочети още', readReview: 'Прочети целия отзив',
    prev: 'Предишна снимка', next: 'Следваща снимка',
  }, CFG.t || {});
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function money(cents) {
    const fmt = CFG.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = (Number(cents) || 0) / 100;
    const split = (v, d, t, s) => {
      const [i, f] = v.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: split(n, 2, ',', '.'),
      amount_no_decimals: split(n, 0, ',', '.'),
      amount_with_comma_separator: split(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: split(n, 0, '.', ','),
    }[k] ?? split(n, 2, '.', ',')));
  }

  const drawer = () => document.querySelector('cart-drawer');

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || CFG.errAdd || 'Грешка при добавяне');
    return data;
  }

  function paint(state) {
    const d = drawer();
    // /cart/add.js не връща item_count; след добавяне количката винаги има артикули
    if (d) d.classList.toggle('is-empty', state.item_count === 0);
    if (d && state.sections) d.renderContents(state);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // 'product-form' = количката вече е нарисувана от отговора (cart.js не я тегли втори път)
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: state });
    }
    refreshPdpTotal();
  }

  const addItems = (items) => post(`${window.routes?.cart_add_url || '/cart/add'}.js`, { items }).then((s) => { paint(s); return s; });
  const changeLine = (id, quantity) => post(`${window.routes?.cart_change_url || '/cart/change'}.js`, { id, quantity }).then((s) => { paint(s); return s; });
  const packItem = (variant, gift, packs = 1) => ({ id: Number(variant), quantity: 3 * packs, properties: { _so_offer: '2+1', _so_gift: gift } });

  /* ---------- поп-ъпът ---------- */
  // Поп-ъпът: на всяко „Добави в количката". Списък: най-големите отстъпки в магазина (/products.json, без лимита
  // на all_products); на страница на серум първо комплектите от data-handles. Маслата отиват най-долу (бележките от 9 окт).
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const ROOT = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const OILS = /олио|масло|ulei|unt /i;
  let catalog = null, catalogKey = null, addedHandle = null;
  // Three Drops: [data-sso-related] дава за всеки серум пакетите, 2+1 и свързаните продукти за лице;
  // тогава поп-ъпът показва само тях (без общите отстъпки), за добавения продукт или за продукта на страницата.
  const TD_KEYS = ['pure-am', 'pure-pm', 'hydra', 'calm', 'lumin', 'renew', 'sculpt', 'cashmere'];
  let related = null;
  try { const el = document.querySelector('[data-sso-related]'); related = el ? JSON.parse(el.textContent) : null; } catch (e) { related = null; }
  function relatedFor(h) {
    if (!related || !h) return null;
    const k = TD_KEYS.find((x) => h.includes(x));
    const l = related[k] || related._all;
    return l ? [...new Set(l.map((x) => x.trim()).filter((x) => x && x !== h))] : null;
  }
  function loadCatalog() {
    const list = document.querySelector('[data-sso-offers-list]');
    if (!list) return Promise.resolve([]);
    const rel = relatedFor(addedHandle || list.dataset.current || '_all');
    const key = rel ? rel.join() : '';
    if (catalog && catalogKey === key) return catalog;
    catalogKey = key;
    const top = rel || [...new Set((list.dataset.handles || '').split(',').filter(Boolean))];
    // RO: /products/<bg-handle>.js дава 404 за преведените handle-и → ?view=sso-json минава през пренасочването
    const one = (h) => fetch(`${ROOT()}products/${h}.js`).then((r) => (r.ok ? r.json() : fetch(`${ROOT()}products/${h}?view=sso-json`).then((x) => (x.ok ? x.json() : null)))).catch(() => null);
    const norm = (p) => { // products.json и /products/x.js дават различни формати
      const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0] || {};
      const cents = (x) => (typeof x === 'string' ? Math.round(parseFloat(x) * 100) : Number(x) || 0);
      const price = cents(v.price), was = cents(v.compare_at_price);
      const img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      return { handle: p.handle, title: p.title, vid: v.id, available: v.available !== false && p.available !== false, price, was: was > price ? was : 0, img: typeof img === 'string' ? img : '' };
    };
    if (rel) {
      const cur = addedHandle || list.dataset.current;
      catalog = Promise.all(top.map(one)).then((ps) => ps.filter(Boolean).map(norm).filter((p) => p.available && p.price > 0 && p.handle !== cur).slice(0, 12));
      return catalog;
    }
    catalog = Promise.all([Promise.all(top.map(one)), fetch(`${ROOT()}products.json?limit=250`).then((r) => r.json()).catch(() => ({ products: [] }))])
      .then(([tops, all]) => {
        const first = tops.filter(Boolean).map(norm).filter((p) => p.available && p.price > 0 && !/Cumpără 2/i.test(p.title)).slice(0, 6);
        const seen = new Set(first.map((p) => p.handle));
        const rest = all.products.map(norm)
          .filter((p) => p.available && p.price > 0 && p.was && !seen.has(p.handle) && !/ваучер|vaucher|voucher|Cumpără 2/i.test(p.handle + ' ' + p.title))
          .sort((x, y) => (OILS.test(x.title) - OILS.test(y.title)) || (y.was - y.price) / y.was - (x.was - x.price) / x.was);
        return first.concat(rest).slice(0, 8);
      });
    return catalog;
  }
  function renderOffers() {
    const list = document.querySelector('[data-sso-offers-list]');
    return Promise.all([loadCatalog(), fetch(`${ROOT()}cart.js`).then((r) => r.json()).catch(() => ({ items: [] }))]).then(([ps, cart]) => {
      const inCart = new Set(cart.items.map((i) => i.handle));
      list.innerHTML = ps.map((p) => {
        const pct = p.was ? Math.round(100 - (p.price * 100) / p.was) : 0;
        const img = p.img ? `${p.img}${p.img.includes('?') ? '&' : '?'}width=200` : '';
        const btn = inCart.has(p.handle) ? `<button type="button" class="sso-offer-btn is-added" disabled aria-label="${T.added}">✓</button>` : `<button type="button" class="sso-offer-btn" data-sso-offer-add="${p.vid}">${T.add}</button>`;
        return `<div class="sso-offer"><img src="${esc(img)}" alt="${esc(p.title)}" width="64" height="64" loading="lazy"><div class="sso-offer-info"><strong>${esc(p.title)}</strong><div class="sso-offer-p"><b>${money(p.price)}</b>${p.was ? `<s>${money(p.was)}</s><em>−${pct}%</em>` : ''}</div></div>${btn}</div>`;
      }).join('');
      return ps.length;
    });
  }
  setTimeout(loadCatalog, 1500); // зарежда се предварително, за да е готов при „Добави в количката"
  function openOffers() {
    if (!document.getElementById('sso-offers') || document.body.classList.contains('sso-offers-open')) return;
    renderOffers().then((n) => { if (n) showOffers(); });
  }
  // бутоните „Добави в количката" на темата (продукти без оферта, карти, бързо добавяне): поп-ъпът след обновяването
  let pendingPopup = false;
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('product-form button[type="submit"], .product-form__submit, .quick-add__submit, button[name="add"]');
    if (addBtn && !e.target.closest('#sso-offers')) {
      pendingPopup = true;
      const card = addBtn.closest('[data-three-drops-handle]');
      addedHandle = card ? card.dataset.threeDropsHandle : null;
    }
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { if (pendingPopup) { pendingPopup = false; setTimeout(openOffers, 400); } });
  }
  function showOffers() {
    document.body.classList.add('sso-offers-open');
    startClock();
  }
  // броячът: 3 мин, само визуален (както на inaessentials.bg); при 00:00 започва отначало
  let clockIv = null;
  function startClock() {
    const el = document.querySelector('[data-sso-clock]');
    if (!el) return;
    let left = 180;
    const paintClock = () => { el.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0'); };
    paintClock(); clearInterval(clockIv);
    clockIv = setInterval(() => { left = left > 0 ? left - 1 : 180; paintClock(); }, 1000);
  }
  const closeOffers = () => { document.body.classList.remove('sso-offers-open'); clearInterval(clockIv); };

  /* ---------- продуктова страница ---------- */
  let cartDisplayTotal = 0;
  function cartTotalFrom(cart) {
    return cart.items.reduce((t, it) => {
      if (it.properties && it.properties._auto_gift) return t - it.final_line_price;
      if (it.properties && it.properties._so_offer) return t - it.final_price * Math.floor(it.quantity / 3);
      return t;
    }, cart.total_price);
  }
  function refreshPdpTotal() {
    if (!document.querySelector('[data-sso-pdp]')) return;
    fetch('/cart.js').then((r) => r.json()).then((c) => { cartDisplayTotal = cartTotalFrom(c); document.querySelectorAll('[data-sso-pdp]').forEach(sync); }).catch(() => {});
  }

  const MILE_ICONS = [
    '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/>',
    '<rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3 9h18M12 9v11"/>',
    '<path d="M4 9h16l-1 11H5zM9 9V6h6v3"/>',
  ];
  function rewards(t) {
    const miles = CFG.miles || [];
    if (!miles.length) return '';
    const max = miles[miles.length - 1].at;
    const next = miles.find((m) => t < m.at);
    const icon = MILE_ICONS[next ? miles.indexOf(next) : miles.length - 1] || MILE_ICONS[0];
    const text = next ? `${T.more} <strong>${money(next.at - t)}</strong> ${T.to} ${next.label}` : T.done;
    return `<div class="sso-rewards-text"><svg viewBox="0 0 24 24" aria-hidden="true">${icon}</svg><span>${text}</span></div>
      <div class="sso-bar"><span class="sso-bar-fill" style="width:${Math.min(100, (t / max) * 100)}%"></span>
      ${miles.map((m, i) => `<span class="sso-mile${t >= m.at ? ' is-reached' : ''}" style="left:${(m.at / max) * 100}%"><span class="sso-mile-dot"><svg viewBox="0 0 24 24" aria-hidden="true">${MILE_ICONS[i] || MILE_ICONS[0]}</svg></span><span class="sso-mile-label">${m.short}<br>${money(m.at)}</span></span>`).join('')}</div>`;
  }

  const selected = (box) => box.querySelector('.sso-tiers input:checked')?.value || '1';
  const selectedPrice = (box) => Number(selected(box) === '2' ? box.dataset.packPrice : box.dataset.price);
  function sync(box) {
    box.querySelectorAll('.sso-tier').forEach((t) => t.classList.toggle('is-on', t.querySelector('input').checked));
    const label = box.querySelector('[data-sso-cta-label]');
    const btn = box.querySelector('[data-sso-add]');
    if (label && btn && !btn.disabled) label.textContent = `${CFG.addLabel || 'Добави в количката'} · ${money(selectedPrice(box))}`;
    const r = box.querySelector('[data-sso-rewards]');
    if (r) r.innerHTML = rewards(cartDisplayTotal + selectedPrice(box));
  }

  function showError(box, msg) {
    const e = box && box.querySelector('[data-sso-error]');
    if (!e) return;
    e.textContent = msg; e.hidden = false;
    setTimeout(() => { e.hidden = true; }, 6000);
  }

  async function busy(el, fn) {
    el.setAttribute('aria-busy', 'true');
    try { await fn(); } finally { el.removeAttribute('aria-busy'); }
  }

  /* ---------- събития ---------- */
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-sso-pdp]');
    if (box && e.target.matches('.sso-tiers input')) sync(box);
  });

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-sso-add]');
    if (add) {
      const box = add.closest('[data-sso-pdp]');
      const tier = selected(box);
      let items = [{ id: Number(box.dataset.variant), quantity: 1 }];
      if (tier === '2') items = box.dataset.bundleVariant ? [{ id: Number(box.dataset.bundleVariant), quantity: 1 }] : [packItem(box.dataset.variant, box.dataset.gift)];
      busy(add, () => addItems(items).then(openOffers).catch((err) => showError(box, err.message)));
      return;
    }
    const one = e.target.closest('[data-sso-add-variant]');
    if (one) { busy(one, () => addItems([{ id: Number(one.dataset.ssoAddVariant), quantity: 1 }]).then(() => {
        if (!one.classList.contains('sso-pc-add')) return;
        one.classList.add('is-added'); one.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>';
      }).catch((err) => showError(one.closest('[data-sso-pdp]') || document.querySelector('[data-sso-pdp]'), err.message))); return; }

    const offer = e.target.closest('[data-sso-offer-add]');
    if (offer) {
      busy(offer, () => addItems([{ id: Number(offer.dataset.ssoOfferAdd), quantity: 1 }])
        .then(() => { offer.textContent = '✓'; offer.classList.add('is-added'); offer.disabled = true; })
        .catch((err) => { offer.textContent = err.message; }));
      return;
    }

    const up = e.target.closest('[data-sso-upgrade]');
    if (up) {
      // Първо се добавя пакетът, после се намалява редът. Ако добавянето се провали, клиентът не губи нищо.
      const { variant, gift, bundle } = up.dataset;
      // Ключът на реда може да се смени след добавянето, затова редът се търси наново по вариант (без _so_offer).
      busy(up, () => addItems([bundle ? { id: Number(bundle), quantity: 1 } : packItem(variant, gift)])
        .then(() => fetch('/cart.js').then((r) => r.json()))
        .then((c) => {
          const i = c.items.findIndex((it) => String(it.variant_id) === variant && !(it.properties && it.properties._so_offer));
          if (i < 0) return null;
          // по ключа от току-що взетия cart.js: номерът на реда (line) не съвпада, когато в количката има пакети (bundles)
          return post(`${window.routes?.cart_change_url || '/cart/change'}.js`, { id: c.items[i].key, quantity: Math.max(0, c.items[i].quantity - 1) }).then(paint);
        })
        .catch((err) => { up.textContent = err.message; }));
      return;
    }

    const pack = e.target.closest('[data-sso-pack]');
    if (pack) { busy(pack, () => changeLine(pack.dataset.ssoPack, Number(pack.dataset.qty)).catch(() => {})); return; }

    const dot = e.target.closest('[data-sso-qc-dot]');
    if (dot) { showQuote(dot.closest('[data-sso-qc]'), Number(dot.dataset.ssoQcDot)); return; }
    const jump = e.target.closest('[data-sso-scroll]');
    if (jump) {
      const t = document.querySelector(jump.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }
      return;
    }
    const more = e.target.closest('[data-sso-more-toggle]');
    if (more) {
      const box = more.previousElementSibling, open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open); more.setAttribute('aria-expanded', open); more.textContent = open ? T.hide : T.readMore;
      return;
    }
    if (e.target.closest('[data-sso-offers-close]')) { closeOffers(); return; }
    if (e.target.closest('[data-sso-offers-skip]')) { closeOffers(); if (window.Shopify?.country !== 'RO') drawer()?.close(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && document.body.classList.contains('sso-offers-open')) { e.stopPropagation(); closeOffers(); } }, true);

  /* „Прочети целия отзив" в картата горе (бутонът се показва само при срязан текст) */
  const qcMore = () => document.querySelectorAll('.sso-qc-slide').forEach((sl) => {
    const q = sl.querySelector('blockquote'), b = sl.querySelector('[data-sso-qc-more]');
    if (q && b && !sl.hidden) b.hidden = !(q.scrollHeight > q.clientHeight + 2) && !sl.classList.contains('is-open');
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sso-qc-more]'); if (!b) return;
    const sl = b.closest('.sso-qc-slide'), box = b.closest('[data-sso-qc]'); const open = !sl.classList.contains('is-open');
    sl.classList.toggle('is-open', open); b.textContent = open ? T.hide : T.readReview; if (box) box.dataset.paused = open ? '1' : '';
  });
  setTimeout(qcMore, 300);

  /* картата с отзиви: сменя се на 6 с, спира при посочване */
  function showQuote(box, i) {
    if (!box) return;
    const slides = box.querySelectorAll('.sso-qc-slide'), dots = box.querySelectorAll('[data-sso-qc-dot]');
    slides.forEach((sl, k) => { sl.hidden = k !== i; });
    dots.forEach((d, k) => d.setAttribute('aria-selected', String(k === i)));
    box.dataset.i = i;
    setTimeout(qcMore, 50);
  }
  document.querySelectorAll('[data-sso-qc]').forEach((box) => {
    const n = box.querySelectorAll('.sso-qc-slide').length;
    if (n < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let paused = false;
    box.addEventListener('mouseenter', () => { paused = true; }); box.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => { if (!paused && !box.dataset.paused && !document.hidden) { showQuote(box, ((Number(box.dataset.i) || 0) + 1) % n); qcMore(); } }, 6000);
  });

  // отзиви: стрелки за плъзгане
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-sso-rv]'); if (!a) return;
    const t = a.closest('.sso-rv').querySelector('[data-sso-rv-track]'); const card = t.querySelector('.sso-rv-card');
    t.scrollBy({ left: Number(a.dataset.ssoRv) * ((card ? card.offsetWidth : 300) + 14), behavior: 'smooth' });
  });
  // стена с отзиви: „Прочети още" само при текст, който не се побира
  document.querySelectorAll('[data-sso-wall] .sso-wcard').forEach((c) => {
    const t = c.querySelector('.sso-wcard-text'), b = c.querySelector('[data-sso-wmore]');
    if (t && b && t.scrollHeight > t.clientHeight + 2) b.hidden = false;
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sso-wmore]'); if (!b) return;
    const c = b.closest('.sso-wcard'); c.classList.toggle('is-open'); b.textContent = c.classList.contains('is-open') ? T.hide : T.readMore;
  });

  /* галерия на продукта: стрелки върху голямата снимка + плъзгане с мишката (през setActiveMedia на темата) */
  const initGallery = () => document.querySelectorAll('media-gallery').forEach((g) => {
    if (typeof g.setActiveMedia !== 'function' || g.dataset.ssoNav) return;
    g.dataset.ssoNav = '1';
    const items = () => [...g.querySelectorAll('.product__media-list > .product__media-item')];
    const cur = () => Math.max(0, items().findIndex((li) => li.classList.contains('is-active')));
    const go = (d) => { const list = items(); if (list.length < 2) return; const n = (cur() + d + list.length) % list.length; g.setActiveMedia(list[n].dataset.mediaId, false);
      const t = g.querySelector(`.thumbnail[data-target="${list[n].dataset.mediaId}"]`); g.querySelectorAll('.thumbnail').forEach((x) => x.removeAttribute('aria-current')); if (t) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } };
    const host = g.querySelector('.product__media-list')?.parentElement; if (!host || items().length < 2) return;
    host.style.position = 'relative';
    const mk = (cls, d, label, path) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'sso-gal-nav ' + cls; b.setAttribute('aria-label', label); b.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}"/></svg>`; b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(d); }); host.appendChild(b); };
    mk('sso-gal-nav--prev', -1, T.prev, 'm15 18-6-6 6-6'); mk('sso-gal-nav--next', 1, T.next, 'm9 18 6-6-6-6');
    let x0 = null;
    host.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') x0 = e.clientX; });
    host.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); });
    host.addEventListener('dragstart', (e) => e.preventDefault());
  });
  if (window.customElements) customElements.whenDefined('media-gallery').then(initGallery); else initGallery();

  /* Instagram карусел: 5 видеа (центърът на фокус), сменят се сами, кръгчетата горе показват кое е минало/текущо */
  document.querySelectorAll('[data-sso-ig]').forEach((root) => {
    const items = [...root.querySelectorAll('.sso-cf-item')], tabs = [...root.querySelectorAll('[data-sso-ig-i]')], stage = root.querySelector('.sso-cf-stage');
    const n = items.length; if (!n) return;
    let cur = 0, timer = null, inView = false;
    const rel = (i) => { let d = ((i - cur) % n + n) % n; if (d > n / 2) d -= n; return d; };
    const layout = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const W = items[0].offsetWidth || 320;
      items.forEach((it, i) => {
        const d = rel(i), a = Math.abs(d), max = mobile ? 1 : 2;
        const scale = a === 0 ? 1 : a === 1 ? 0.8 : 0.64;
        const x = d === 0 ? 0 : Math.sign(d) * (a === 1 ? W * 0.9 + 14 : W * 1.62 + 28); // без застъпване
        it.style.transform = `translateX(calc(-50% + ${x}px)) scale(${a > max ? 0.5 : scale})`;
        it.style.zIndex = String(10 - a);
        it.style.opacity = a > max ? '0' : '1';
        it.style.pointerEvents = a > max ? 'none' : 'auto';
        it.classList.toggle('is-on', a === 0); it.classList.toggle('is-side', a !== 0);
        const v = it.querySelector('video');
        if (v) { if (a === 0 && inView) { v.play().catch(() => {}); } else { v.pause(); if (a !== 0) { v.muted = true; it.querySelector('[data-sso-vtile]')?.classList.remove('is-sound'); } } }
      });
      tabs.forEach((t, i) => { t.setAttribute('aria-selected', String(i === cur)); t.closest('li').classList.toggle('is-seen', rel(i) < 0); });
      // само редът с кръгчетата се превърта настрани; страницата не мърда
      const active = tabs[cur], row = active && active.closest('ul');
      if (row && row.scrollWidth > row.clientWidth) { const li = active.closest('li'); row.scrollTo({ left: li.offsetLeft - (row.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' }); }
    };
    const go = (i) => { cur = ((i % n) + n) % n; layout(); arm(); };
    const arm = () => { clearTimeout(timer); if (!inView) return; const v = items[cur].querySelector('video');
      const ms = v && v.duration && isFinite(v.duration) ? Math.min(v.duration * 1000, 20000) + 300 : 9000;
      timer = setTimeout(() => { const vv = items[cur].querySelector('video'); if (vv && !vv.muted) { arm(); return; } go(cur + 1); }, ms); };
    items.forEach((it, i) => {
      const v = it.querySelector('video'); if (v) { v.addEventListener('ended', () => { if (i === cur && v.muted) go(cur + 1); else if (i === cur) { v.currentTime = 0; v.play().catch(() => {}); } }); v.addEventListener('loadedmetadata', () => { if (i === cur) arm(); }); }
      it.addEventListener('click', (e) => { if (i !== cur) { e.preventDefault(); e.stopPropagation(); go(i); } }, true);
    });
    tabs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    root.querySelectorAll('[data-sso-cf-step]').forEach((b) => b.addEventListener('click', () => go(cur + Number(b.dataset.ssoCfStep))));
    let x0 = null; stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; }); stage.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); });
    window.addEventListener('resize', layout);
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { inView = en.isIntersecting; layout(); arm(); }, { threshold: 0.3 }).observe(stage);
    layout();
  });

  /* BOX NOW: безплатна доставка до 31.10.2026 23:59 (София); след това редът изчезва сам */
  const BN_END = Date.parse('2026-10-31T23:59:59+02:00');
  {
    const tick = () => {
      const bnEls = document.querySelectorAll('[data-sso-bn-cd]'); // и редовете в количката, която се прерисува
      const ms = BN_END - Date.now();
      if (ms <= 0) { bnEls.forEach((e) => { e.hidden = true; }); return false; }
      const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      const txt = `до 31 октомври · остават ${d ? d + ' д. ' : ''}${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      bnEls.forEach((e) => { e.textContent = txt; e.hidden = false; });
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  }

  /* видеата в секцията: тръгват без звук, когато се видят; бутонът пуска звука само на едно видео */
  const vtiles = document.querySelectorAll('[data-sso-vtile] video');
  if (vtiles.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { const v = en.target; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: 0.4 });
    vtiles.forEach((v) => io.observe(v));
  }
  document.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-sso-vtile]'); if (!tile) return;
    const v = tile.querySelector('video'); const on = v.muted;
    document.querySelectorAll('[data-sso-vtile]').forEach((t) => { const x = t.querySelector('video'); x.muted = true; t.classList.remove('is-sound'); });
    v.muted = !on; if (on) { v.currentTime = 0; v.play().catch(() => {}); tile.classList.add('is-sound'); }
    tile.querySelector('[data-sso-sound]').setAttribute('aria-label', on ? 'Спри звука' : 'Включи звука');
  });

  /* „Купи 2, вземи 1“ за всеки 2 платени бройки; подаръкът е само 1 на продукт (28.10.2026, след поръчка #173481).
     Данните идват от [data-sso-auto] в кутията на количката (so-cart-offers.liquid, part 'upgrade'):
       {variant, qty, bundle, nogift} 2+ отделни броя → 1 пакет (с подарък, или без, ако пакетът с подарък вече е вътре),
                                      останалите остават отделно и при следващото обновяване стават пакети без подарък;
       {trim, base, more}             пакет с подарък над 1 → 1, излишните → пакети без подарък (или по 2 отделни броя);
       {swap, bundle}                 пакет без подарък, а пакетът с подарък липсва → един от тях става пакет с подарък. */
  let packing = false;
  async function autoPack() {
    const els = document.querySelectorAll('cart-drawer [data-sso-auto]');
    if (packing || !els.length) return;
    let lines;
    try { lines = [...els].flatMap((el) => JSON.parse(el.textContent)); } catch (e) { return; }
    if (!lines.length) return;
    packing = true;
    try {
      let state;
      const add = `${window.routes?.cart_add_url || '/cart/add'}.js`, change = `${window.routes?.cart_change_url || '/cart/change'}.js`;
      for (const l of lines) {
        if (l.trim) {
          await post(add, { items: [l.more ? { id: Number(l.more), quantity: l.trim - 1 } : { id: Number(l.base), quantity: 2 * (l.trim - 1) }] });
          state = await post(change, { id: l.key, quantity: 1 });
          continue;
        }
        // офертата в количката: махане (без продукт за лице/тяло, след 05.11) или най-много 1 брой
        if (l.set !== undefined) {
          state = await post(change, { id: l.key, quantity: l.set });
          continue;
        }
        if (l.swap) {
          await post(add, { items: [{ id: Number(l.bundle), quantity: 1, properties: { _sso_auto: '1' } }] });
          state = await post(change, { id: l.key, quantity: l.swap - 1 });
          continue;
        }
        // първо пакетът, после се намалява редът (като бутона в кутията): ако добавянето се провали, клиентът не губи нищо
        state = await post(add, { items: [l.bundle ? { id: Number(l.bundle), quantity: 1, properties: { _sso_auto: '1' } } : packItem(l.variant, l.gift, 1)] });
        const c = await fetch('/cart.js').then((r) => r.json());
        const it = c.items.find((x) => String(x.variant_id) === String(l.variant) && !(x.properties && x.properties._so_offer));
        if (it) state = await post(change, { id: it.key, quantity: l.qty - 2 });
      }
      paint(state);
    } catch (err) {
      // при грешка количката остава както е (отделните бройки), нищо не се губи
    } finally {
      packing = false;
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(autoPack, 0));
  autoPack();

  document.querySelectorAll('[data-sso-pdp]').forEach(sync);
  refreshPdpTotal();
})();

/* Оферта „само сега в количката“ (28.10.2026): 5 мин. на сесия от първия показ; после блокът се скрива
   (класът sso-xs-off на <html>, затова не мига при прерисуване на количката). */
(function () {
  const KEY = 'sso_xs_t0', LEN = 5 * 60 * 1000, root = document.documentElement;
  const get = () => { try { return Number(sessionStorage.getItem(KEY)) || 0; } catch (e) { return 0; } };
  const set = (v) => { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} };
  function tick() {
    const clocks = document.querySelectorAll('[data-sso-xs-clock]');
    let t0 = get();
    if (!t0 && clocks.length && document.querySelector('cart-drawer.active, cart-drawer[open], .drawer.active')) { t0 = Date.now(); set(t0); }
    if (!t0) return;
    const left = Math.max(0, t0 + LEN - Date.now());
    if (!left) { root.classList.add('sso-xs-off'); return; }
    const s = Math.ceil(left / 1000), txt = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    clocks.forEach((c) => { c.textContent = txt; });
  }
  if (get() && get() + LEN <= Date.now()) root.classList.add('sso-xs-off');
  setInterval(tick, 1000);
  tick();
})();
